import React from "react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react";
import { useWebGalleryStore, useBreakpoint } from "../../hooks";
import { AssetTile } from "../../lib/AssetTile";

export interface GalleryGridProps {
  galleryId: string;
  galleryAssets: IAsset[];
}

export const GalleryGrid = observer(
  ({ galleryId, galleryAssets }: GalleryGridProps): JSX.Element => {
    const store = useWebGalleryStore();
    const { isDesktop } = useBreakpoint();
    const baseGridItemWidth = 193;
    const baseGridItemHeight = 128;

    const determineGridLayout = () => {
      // only show zoom controls on desktop
      // pass in zoom level to determine grid column styles
      if (!isDesktop) {
        return "zoom-container";
      } else if (store.zoomLevel && store.zoomLevel <= 400) {
        return `zoom-container zoom-container__zoom-${store.zoomLevel}`;
      } else {
        return "zoom-container zoom-container__zoom-full";
      }
    };

    const getGridItemDimensions = () => {
      // don't calculate if supports css variable
      if (window.navigator.userAgent.indexOf('Trident') == -1 && window.navigator.userAgent.indexOf('Edge') == -1 ) {
        return
      }
        let width = baseGridItemWidth;
        let height = baseGridItemHeight;
        if (store.zoomLevel) {
          width = baseGridItemWidth * (store.zoomLevel / 100);
          height = baseGridItemHeight * (store.zoomLevel / 100) + 30;
        }

        return {
          width: width + "px",
          height: height + "px"
        }
    }

    return (
      <div className="zoom-container--outer-wrapper">
        <div className={determineGridLayout()}>
          {galleryAssets.map((item) => {
            return (
              <div key={item.id} className="grid-item" style={getGridItemDimensions()}>
                <Link
                  className="grid-item__link"
                  to={`/${galleryId}-ExternalUser/${item.id}`}
                >
                  <AssetTile item={item} />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
);
